import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import MainLayout from '../../../layouts/MainLayout';
import { Loader, Center } from '@/components/ui';

// Eager load dashboard for instant access
import VendorsDashboard from './dashboard';

// Lazy load other pages for better performance
const VendorListPage = lazy(() => import('./list'));
const VendorDetailPage = lazy(() => import('./view/[id]'));
const VendorBulkImportPage = lazy(() => import('./BulkImport'));
const ProductsListPage = lazy(() => import('./products'));
const ProductDetailPage = lazy(() => import('./products/[id]'));
const RatingsPage = lazy(() => import('./ratings'));
const EventsListPage = lazy(() => import('./events'));
const NewEventPage = lazy(() => import('./events/new'));
const EditEventPage = lazy(() => import('./events/edit/[id]'));
const EventDetailPage = lazy(() => import('./events/[id]'));
const OrdersPage = lazy(() => import('./orders'));
const ReportsPage = lazy(() => import('./reports'));
const PaymentsPage = lazy(() => import('./payments'));
const SettingsPage = lazy(() => import('./settings'));
const AdminPage = lazy(() => import('./admin'));
const AdminLookupsPage = lazy(() => import('./admin/lookups'));
const LookupCategoryPage = lazy(() => import('./admin/lookups/[category]'));
const LookupManagementPage = lazy(() => import('./admin/lookups/[category]/[lookup]'));

// Loading fallback
const LoadingFallback = () => (
  <Center h={400}>
    <Loader size="lg" />
  </Center>
);

/**
 * Vendor Management Routes
 * Admin routing configuration for Vendors domain with MainLayout
 */
export default function VendorManagementRoutes() {
  return (
    <MainLayout domainKey="vendors">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Dashboard - Default route */}
          <Route path="/" element={<VendorsDashboard />} />

          {/* Vendor List */}
          <Route path="/list" element={<VendorListPage />} />

          {/* Vendor Bulk Import */}
          <Route path="/bulk-import" element={<VendorBulkImportPage />} />

          {/* Vendor Detail View */}
          <Route path="/view/:id" element={<VendorDetailPage />} />

          {/* Products Management */}
          <Route path="/products" element={<ProductsListPage />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />

          {/* Ratings Management */}
          <Route path="/ratings" element={<RatingsPage />} />

          {/* Events Management */}
          <Route path="/events" element={<EventsListPage />} />
          <Route path="/events/new" element={<NewEventPage />} />
          <Route path="/events/edit/:id" element={<EditEventPage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />

          {/* Orders Management - Coming Soon */}
          <Route path="/orders" element={<OrdersPage />} />

          {/* Reports - Coming Soon */}
          <Route path="/reports" element={<ReportsPage />} />

          {/* Financial Management */}
          <Route path="/payments" element={<PaymentsPage />} />

          {/* System Settings */}
          <Route path="/settings" element={<SettingsPage />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/lookups" element={<AdminLookupsPage />} />
          <Route path="/admin/lookups/:category" element={<LookupCategoryPage />} />
          <Route path="/admin/lookups/:category/:lookup" element={<LookupManagementPage />} />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/app/vendors" replace />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}
